import React from "react";
import { Card } from "primereact/card";
import { SectionHeader } from "./SectionHeader";
import { ComparisonPanel } from "./ComparisonPanel";

interface AiSummarySectionProps {
    title: string;
    index: number;
    originalText: string;
    editableText: string;
    sectionKey: string;
    isExpanded: boolean;
    hasBeenEdited: boolean;
    onToggle: () => void;
    onTextChange: (value: string) => void;
    onSave: () => void;
}

export const AiSummarySection: React.FC<AiSummarySectionProps> = ({
    title,
    index,
    originalText,
    editableText,
    sectionKey,
    isExpanded,
    hasBeenEdited,
    onToggle,
    onTextChange,
    onSave
}) => {
    const getWordCount = (text: string): number => {
        return text.trim().split(/\s+/).filter(word => word.length > 0).length;
    };

    const getWordDifference = (originalText: string, aiText: string) => {
        const originalCount = getWordCount(originalText);
        const aiCount = getWordCount(aiText);
        const difference = aiCount - originalCount;
        
        if (difference > 0) {
            return { difference, type: 'added' as const };
        } else if (difference < 0) {
            return { difference: Math.abs(difference), type: 'removed' as const };
        } else {
            return { difference: 0, type: 'same' as const };
        }
    };

    const wordDifference = getWordDifference(originalText, editableText);

    return (
        <div className="col-12 mb-4">
            <Card className="shadow-2">
                <div className="mb-3">
                    <SectionHeader
                        title={title}
                        index={index}
                        isExpanded={isExpanded}
                        wordDifference={wordDifference}
                        onToggle={onToggle}
                    />
                </div>
                
                {!isExpanded && (
                    <div className="text-center py-3">
                        <p 
                            className="m-0 text-500 text-sm cursor-pointer hover:text-primary transition-colors transition-duration-200"
                            onClick={onToggle}
                        >
                            <i className="pi pi-chevron-down mr-2"></i>
                            Expand to see content
                        </p>
                    </div>
                )}
                
                {isExpanded && (
                    <div className="grid">
                        <div className="col-12">
                            <ComparisonPanel
                                originalText={originalText}
                                editableText={editableText}
                                sectionKey={sectionKey}
                                hasBeenEdited={hasBeenEdited}
                                onTextChange={onTextChange}
                                onSave={onSave}
                            />
                        </div>
                    </div>
                )}
            </Card>
        </div>
    );
};